//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { OpOperator, OpRoute } from '../../models/core'


//#region Public Types

export const ROUTE_FITTER_SERVICE_NAME = 'RouteFitterService'
export const ROUTE_FITTER_SERVICE_PROVIDER_NAME = 'RouteFitterServiceProvider'

//#endregion


export class RouteFitterService {

    //#region Costs

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Route.Fitter]' }

    //#endregion


    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Operator

    public getFitterOperator(route: OpRoute): JQueryPromise<OpOperator> {
        if (route == null || route.idOperatorExecutor == null) {
            return $.Deferred().resolve(null).promise()
        }

        return this.userSessionService
            .getDataProvider().Operator
            .getFitterOperators([route.idOperatorExecutor])
            .then((fitterOperators: OpOperator[]) => {
                return _.first(fitterOperators)
            })
    }

    //#endregion
}

export class RouteFitterServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
            return new RouteFitterService(userSessionService)
        }]

    //#endregion
} 